export default "# Generates a teal circle\n\nCircle ← > · 0‿255‿255‿255⊸×¨ 1 > · +´⌾(⋆⟜2)¨ 2 × 0.5 -˜ ⊢ ÷˜ ↕∘≍˜\n\nCircle 256\n";